import { FormCategory, OrganizationCountry } from "@simplyk/common";

import { DonationFormWithUserOrOrgAccessOutput, TicketingOutput } from "@/types/trpc";

export const isTicketing = (form: TicketingOutput | DonationFormWithUserOrOrgAccessOutput): form is TicketingOutput => {
  return Boolean((form as TicketingOutput).ticketingFields);
};

export const isDonationForm = (
  form: TicketingOutput | DonationFormWithUserOrOrgAccessOutput
): form is DonationFormWithUserOrOrgAccessOutput => {
  return Boolean((form as DonationFormWithUserOrOrgAccessOutput).donationFormFields);
};

export const isFormCategory = (category: unknown): category is FormCategory => {
  return typeof category === "string" && Object.values(FormCategory).includes(category as FormCategory);
};

export const isAddressMandatory = (
  organization?: {
    canGenerateReceipt?: boolean;
    hasConnectedSwiftaidAtUtc?: string | null;
    country?: OrganizationCountry;
  } | null,
  formHasReceipt?: boolean
) => {
  // If the organization can generate receipts and receipts are enabled on the form, we need to ask for the address
  if (organization?.country === OrganizationCountry.Canada) {
    return Boolean(organization?.canGenerateReceipt && formHasReceipt);
  }

  // GB: If the organization has a connected Swiftaid account, we need to ask for the address
  if (organization?.country === OrganizationCountry.GreatBritain) {
    return Boolean(organization.hasConnectedSwiftaidAtUtc);
  }

  return false;
};

export const mustDisplayAddressQuestion = ({
  displayGenerateReceipt,
  organization,
  hasGiftAidConfirmation,
  formData,
}: {
  displayGenerateReceipt?: boolean;
  hasGiftAidConfirmation?: boolean;
  organization: { country: OrganizationCountry };
  formData: { askForAddress?: boolean };
}) => {
  // If the organization can generate receipts and receipts are enabled on the form, we need to ask for the address
  if (organization?.country === OrganizationCountry.Canada) {
    if (displayGenerateReceipt) {
      return true;
    }
    return Boolean(formData.askForAddress);
  }

  // GB: If the organization has a connected Swiftaid account, we need to ask for the address
  if (organization?.country === OrganizationCountry.GreatBritain) {
    if (hasGiftAidConfirmation) {
      return true;
    }
    return Boolean(formData.askForAddress);
  }

  if (organization?.country === OrganizationCountry.UnitedStates) {
    return Boolean(formData.askForAddress);
  }

  return false;
};
